<template>
  <span>
    <span>{{ output }}</span>
    <template v-if="enableEllipsis">
      <span v-if="!isFull">{{ ellipsis }}</span>
      <span
        class="more-less"
        @click="isFull = !isFull"
      >{{ $t('utils.' + (isFull ? 'less' : 'more')) }}</span>
    </template>
  </span>
</template>

<script>
export default {
  name: 'ITextCollapse',
  props: {
    text: {
      type: String,
      default: ''
    },
    limit: {
      type: [Number, String],
      default: 100
    }
  },
  data: () => ({
    isFull: false,
    ellipsis: '...'
  }),
  computed: {
    output () {
      if (!this.text) {
        return '-'
      }
      if (this.isFull) {
        return this.text
      }
      return this.text.slice(0, this.maxLength)
    },
    enableEllipsis () {
      return this.text.length > this.maxLength
    },
    maxLength () {
      return this.limit - this.$t('utils.more').length - this.ellipsis.length
    }
  }
}
</script>

<style lang="stylus" scoped>
.more-less {
  text-decoration: underline
  cursor: pointer
}
</style>
